import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useAddEventSessionAttendees } from 'actions/eventSessions';
import useUniqueId from 'hooks/useUniqueId';
import SimpleModal from 'components/SimpleModal';
import Stack from 'components/Stack';
import Alert, { AlertTypes } from 'components/Alert';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import { Select } from 'components/Select';
import EmptyStateController from 'components/EmptyStateController';
import { getCardWithAttendeePills, renderAttendeeStatusOptions } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmAttendeeSelectionModal(_ref) {
  var isLoading = _ref.isLoading,
    isError = _ref.isError,
    eventId = _ref.eventId,
    sessionId = _ref.sessionId,
    memberTypeToAdd = _ref.memberTypeToAdd,
    membersCount = _ref.membersCount,
    sessionCapacity = _ref.sessionCapacity,
    sessionAttendeesCount = _ref.sessionAttendeesCount,
    conflictUsers = _ref.conflictUsers,
    noAccessUsers = _ref.noAccessUsers,
    pendingMemberIds = _ref.pendingMemberIds,
    pendingTeams = _ref.pendingTeams,
    onClose = _ref.onClose,
    onEdit = _ref.onEdit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('booked'),
    _useState2 = _slicedToArray(_useState, 2),
    attendeeStatus = _useState2[0],
    setAttendeeStatus = _useState2[1];
  var attendeeStatusLabelId = useUniqueId();
  var hasMembersToAdd = membersCount > 0;
  var isTeamSelection = memberTypeToAdd === 'team';
  var _useAddEventSessionAt = useAddEventSessionAttendees({
      eventId: eventId,
      sessionId: sessionId
    }),
    isSubmitPending = _useAddEventSessionAt.isPending,
    addEventSessionAttendees = _useAddEventSessionAt.addEventSessionAttendees;
  function onConfirmAddMembers() {
    return _onConfirmAddMembers.apply(this, arguments);
  }
  function _onConfirmAddMembers() {
    _onConfirmAddMembers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (hasMembersToAdd) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            _context.next = 2;
            return addEventSessionAttendees({
              status: attendeeStatus,
              attendeeIds: pendingMemberIds
            });
          case 2:
            onClose();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onConfirmAddMembers.apply(this, arguments);
  }
  var hasNoAccessUsers = membersCount > 0 && noAccessUsers.length > 0;
  var totalAttendeesCount = membersCount + sessionAttendeesCount;
  var alerts = [typeof sessionCapacity === 'number' && totalAttendeesCount > sessionCapacity && hasMembersToAdd && /*#__PURE__*/_jsx(Trans, {
    i18nKey: "modal_confirm_attendees_alert_over_session_capacity",
    values: {
      sessionCapacity: sessionCapacity,
      count: totalAttendeesCount
    }
  }), !membersCount && /*#__PURE__*/_jsx(Trans, {
    i18nKey: "modal_confirm_attendees_alert_no_members",
    values: {
      count: pendingTeams.length
    }
  }), (attendeeStatus === 'booked' || attendeeStatus === 'attended') && conflictUsers.length > 0 && /*#__PURE__*/_jsx(Trans, {
    i18nKey: "modal_confirm_attendees_alert_booking_conflict",
    count: conflictUsers.length
  })].filter(Boolean);
  return /*#__PURE__*/_jsx(SimpleModal, {
    width: "wide",
    title: t(isTeamSelection ? 'modal_confirm_attendees_title_team' : 'modal_confirm_attendees_title_member'),
    body: /*#__PURE__*/_jsx(EmptyStateController, {
      isLoading: isLoading,
      isError: isError,
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Trans, {
          i18nKey: "modal_confirm_attendees_message",
          values: {
            count: membersCount
          }
        }), /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
          horizontal: true,
          horizontalBreakpoint: "base",
          horizontalLabelWidth: 165,
          children: /*#__PURE__*/_jsx(FormField, {
            as: "span",
            label: t('property_attendance_status_colon'),
            labelId: attendeeStatusLabelId,
            required: true,
            children: /*#__PURE__*/_jsx(Select, {
              size: "medium",
              labelledById: attendeeStatusLabelId,
              menuPlacement: "bottom-start",
              value: attendeeStatus,
              onChange: function onChange(newStatus) {
                return setAttendeeStatus(newStatus);
              },
              children: renderAttendeeStatusOptions()
            })
          })
        }), alerts.map(function (alert, index) {
          return /*#__PURE__*/_jsx(Alert, {
            type: AlertTypes.FAIL,
            children: alert
          }, index);
        }), conflictUsers.length > 0 && getCardWithAttendeePills({
          headingText: t('modal_confirm_attendees_already_booked_members_title'),
          isTeamSelection: isTeamSelection,
          users: conflictUsers,
          teams: pendingTeams
        }), hasNoAccessUsers && /*#__PURE__*/_jsx(Alert, {
          type: AlertTypes.FAIL,
          children: /*#__PURE__*/_jsx(Trans, {
            i18nKey: "modal_confirm_attendees_alert_partial_members",
            values: {
              count: noAccessUsers.length
            }
          })
        }), hasNoAccessUsers && getCardWithAttendeePills({
          headingText: t('modal_confirm_attendees_no_access_members_title'),
          isTeamSelection: isTeamSelection,
          users: noAccessUsers,
          teams: pendingTeams
        })]
      })
    }),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose,
      isDisabled: isSubmitPending
    }, {
      label: t('actions_edit_selection'),
      onClick: onEdit,
      isDisabled: isSubmitPending
    }, {
      label: t('actions_add'),
      onClick: onConfirmAddMembers,
      variant: 'primary',
      isDisabled: !hasMembersToAdd,
      isLoading: isSubmitPending
    }],
    onClose: onClose
  });
}